<!--  -->
<template>
  <section class="seckill-xwrap">
    <div class="seckill">
      <img src="~@/assets/images/product/new/seckill-bg.png" alt="" srcset="" />
      <div class="left">
        <div class="t">
          <span class="tips">
            <span class="icon pf-medium">¥</span>
            <span class="count pf-medium"
              >{{ mixInfo.minPrice
              }}<span class="line" v-if="moreCmmdtySpecs">起</span></span
            >
          </span>
          <span class="sk pf-simbold">{{ mixInfo.buyNowSubtitle }}</span>
          <ShareEarn></ShareEarn>
        </div>
        <div class="normal">
          普通售卖价<i class="n-icon">¥</i
          >{{ seckillData && seckillData.presentPrice / 100
          }}<span class="line" v-if="moreCmmdtySpecs">起</span>
        </div>
      </div>
      <div class="right">
        <div class="t">距结束还剩</div>
        <div class="b">
          <span class="num number500" v-if="time.d * 1 !== 0">{{
            time.d
          }}</span>
          <span class="string" v-if="time.d * 1 !== 0">天</span>
          <span class="num number500">{{ time.h }}</span>
          <span class="string">:</span>
          <span class="num number500">{{ time.m }}</span>
          <span class="string">:</span>
          <span class="num number500">{{ time.s }}</span>
        </div>
      </div>
    </div>
    <div class="suptitle">
      <div class="title pf-medium">{{ productTitle }}</div>
      <ShareButton
        v-if="showShare"
        class="share"
        :promotion-info="sharePromotion"
      >
        <div class="share_btn">
          <img
            class="img"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAQqADAAQAAAABAAAAQgAAAADorYEXAAAIZUlEQVR4Ae1bXWxURRTutk1F7SaENkprDG2N3f7AA0EUFEOD+kA0KQ80qRoQCCEBfMYHIFaRB/XFxIjoAyKobbKQQGJCTBRLEIo/hAdoaWugEGNLk0LUVo1N2/X7YO7mzNy5u3e797Jb0pvszpkzZ86c8+2ZmTs/W1Aw+8wiMIuABYGIhRc6a/Xq1fddu3ZtPhqKJhKJaCQSGbl8+fKvfhqur69/HHUe8SMrZAapH+0kBE8jQweisbGxZGpqahmMX4XPU2g9hnQB0kJpCYzc19fXt13yTDoWi32EuttMvs/8n4WFhR9XV1e3nThx4j+zTihAtLW1FXZ0dDwPo9ejwTVIHzQbtuWLiopqvSKDkTA5Odlvq5cJD4D/UlNTs8IEQ/tVMlFok21qappTW1u7rb29/Sqi4BsA8KpfEGz6wuDBnicGBgbaTN2BAAHlEYTtxqGhoatogOHL0M/oYdfwigYqUn18X0ZKPYTxI22lzbJYy8gCvzTGgIaJiYlPofiZdHXg7A3InYVcH+gr+PwBehTpQCoQpF4/gyXa4A+8G2mTqstBUvMV40Wst7c32dWKleC0EnSDNQDhMBos9VIAJ3tRdhzpcTh7DqnnyO2lQ/IVYJ4zDLpnMSLzKwECq2sgKH2VSLMHAl1hJxrbg4+tkQI4HMfg91ZPT0+3apg8hwwlFSC0ZNpAxhGxfPny+2/evHkAALTaGoOzp4qLi3d0d3f/ZCsPi5cKBNjUaUSIy4yMgFAgnISWZS5NBQXD6Heb0e++tpSFykoDQhyN78enKZURGc0ajAQos4FwoaSkZGk+glBRUfEKImIqFQgs8w0ExoRdkHd1BzRyJBqNrrh06dJv6RoLujxdJBCEzs7OCT/t+uoanB3Qx942FQKE9xEFbyDNaiYw9frJBwkC20sbEXxPgKNfQFYb8hkJ9woIaYHg1Khelsy1woXS0tLX7oVIIAh8UkZEXV3dBoBhvjEOY2BsPn/+/D93VNy976C7g7TcEwg0OgeCe6UwaU6RM31gNH1i3nOwHBwc3ITyClkJXeFUvk6RfmcH6Y+krRHR0tJSBKd3SEHSfGM0eWHng+gO8OV3006TV2QKMI9l6gsYG16XZagYx4LnA8kLmw4CBNo4MjJyq7y8/CGQS5mHL/sQ2YdJO481IgDCekfASbmAcui7kQYFgmMrtwG5A8aPbUtQezdgJe4xYsq8BTCSUyYQ7EXlekdp2GnQIPix1xUR6BbcaE2CoJQc96MsCJlcgEC7XUAAhFWmQ5gyj5m8MPK5AoG+2IDglnvyQbe4gc2VH5OMkIhcgkCXXECAF5O+IkLOAoxQF1W5BsEFBE+g4PgCCQToPiMfeBZ7jB+iXdf2Gn6AeCZL6WwM0yJCHcNpPBhzJZsG0tVdsmTJAwBhiykXBgjcAefHbIt5zWnko6YQDOKWe2gPNnXGoXxMNhAGCDwu5EkZP6Rle6Q1IPDLuICAzKhZKcg81whwfDN0/oXPFOj9QXcHdRaSPDOFn9vMyNCACNLBTHThZS1eWVlZhuiIgt6a7QLKbBuOV1t45ZKnrT7xa9h+fVuUSB2B0Mp5X/uL02jQ5YPpqxkRLiCA5txpNJxXVTx80HzVgKiqqroBD7Stbyh5LK+8moYxFh+mlK9JbRoQvDOAkLmeLL1DaC9YRtlMyWo+0Ec/9yO0FyhUehqIulapMwUB2k4fDHs1H1mmRQQZqKStK6BofkNDg7b+oNxMeTBNcjU9X9qL/DmZJ20D4qQphKX5GpM3U/Jwutm0FZsz35s8FxBYcvMOw9+GoEuZUZ7PWc12+kYfTYNdQOA4n6+82v4DUK1D92g0K+d7njbTdsPOY8pHje0CgqVA7ZAmhQze0d80efmet9ls841+WIFYtGjRd6igTaNAtgX7mU/mu/OOfbSVNjt5pvSptbX1W8lzaOt2PnakEmVlZewiLzqCTKG4FnckDkpevtLz5s37ErZVGfbtPHr0qPUmjzUiWBmLoANAcEgqAhArcR76kuTlI00baau0jb7QJ8mTdMoXJazbN0KhWZmHwEtzcf4pDfeiFy5c+Oj4+PjPKH9YygCITVjZfiZ5kk4JBECIAN3TSM0T8Qu8JZOLE3FpvElzt2t0dPQH8BfLMoBwBidbzyJNSL6kPbsGhVgR551bkGo7SChaPDY29jmBkspySdMW2kTbpB20XfngCQLlUwJBAcy5PWhkHUhNEXhrES3v5gMYtEHZspY2iwdFiXX0QfCspO9fFOMFL5i+Y2oB4kd4eyZX3YTdQUWnCQIjehfGBdcdD9MH5n0DQWFcKmtH4rpZBx6vFzbf7QFUDYw8jtS6A/J8Ovr7+1++Q6b/Tts1pAq8W2xC3vWeDt5ijtSctqR8mDTbUrODDYRzylbfJmQUEdTqXEEGaYsMhmOoV5D5xojT+vfQTVd6eNlBELq6uv71KLeyMwbC0aLGjD3IW3UAENeldKfudFIuoLh2AADaa7PQxR2Y3X7HBFHvNml1whTyyvMiKhr39TcFnqjzMBny2uzjpRsOR7ghpPZCmpE3V5HJqtA5hvJ1GBO0VXNSwAeRFRDUr36pT2CI+dLlah4GW/+4ogT5j7+5+HCzOAZZbhFqO0suhWBA7gzfE/xMkbb6Di9rIKgIBnMe3wByL+gK8sJ+AADXQTvxxngQtK8oS2VTRrOGlyIawvd4HNXVQGY78te9ZLPlK93b2RbbDAIE2hRIRJjO8XrixYsXn0N0rEeZ7787mnqcPJzl1uExpIe4VxKPxyedsqDSUICQxvFymrqXlfIPsKIOD4IZUfwDHAfXk9xjtG2viTpZk6EDYbMQN2TmDA8Pc5l8+y/RlIHDPIIb5QmUefjC8tlnFoFZBHKCwP+f9DqiWJk5DQAAAABJRU5ErkJggg=="
          />
          <span>分享</span>
        </div>
      </ShareButton>
    </div>
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import ShareButton from '@/components/share/ShareButton.vue'
import mixProm from '@/mixin/mixProm'
import { mapState } from 'vuex'
import ShareEarn from '../shareEarn/index'
import utils from '@/plugins/utils'
export default {
  mixins: [mixProm],
  //import引入的组件需要注入到对象中才能使用
  components: { ShareEarn, ShareButton },
  data() {
    //这里存放数据
    return {
      showShare: false,
      isDefault: false,
      isBefore: false,
      isStart: false,
      isEnd: false,
      time: {
        d: '',
        h: '',
        m: '',
        s: ''
      },
      timer: null,
      nowTime: ''
    }
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState([
      'viewName',
      'comments',
      'commentCount',
      'selectedWorker',
      'selectedAddress',
      'selectedTime',
      'locationInfo',
      'selectedSku',
      'isMinProgram',
      'otherServiceDatas'
    ]),
    ...mapState('promotionInfo', {
      promotionInfo: state => state.promotionInfo
    }),
    sharePromotion() {
      if (this.mixInfo && this.mixInfo.isSeckill) {
        return {
          price: this.mixInfo.minPrice * 100,
          tag: '秒杀',
          title: this.productTitle
        }
      }
      return {}
    },
    productTitle() {
      return this.selectedSku.skuName || this.product.spuName
      //
    },
    seckillData() {
      return this.mixInfo.seckillData || {}
    },
    serviceTime() {
      const nt = new Date().getTime()
      const st = this.seckillData && (this.seckillData.serviceTime || nt)
      return st
    },
    startTime() {
      const ts = this.seckillData && this.seckillData.startTime
      const ft = this.getTime(ts)
      return ft
    },
    endTime() {
      const ts = this.seckillData && this.seckillData.endTime
      const ft = this.getTime(ts)
      return ft
    },
    timeOffset() {
      const nt = new Date().getTime()

      return this.serviceTime - nt
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    countDown(cbCount, cbFin) {
      this.timeOut(cbCount, cbFin)
      this.timer = setInterval(() => {
        this.timeOut(cbCount, cbFin)
      }, 1000)
    },
    timeOut(cbCount, cbFin) {
      const nowTime = this.nowTime
      const timeDiff = this.startTime - nowTime
      let remain = 0

      if (timeDiff <= 0 && this.endTime > nowTime) {
        this.isStart = true
        remain = (this.endTime - nowTime) / 1000
        cbCount(remain)
      }
      if (timeDiff <= 0 && this.endTime <= nowTime) {
        clearInterval(this.timer)
        this.isDefault = false
        this.isBefore = false
        this.isStart = false
        this.isEnd = true
        cbFin(remain)
      }
      this.nowTime = new Date().getTime() + this.timeOffset
    },
    splitTime(remain) {
      const t = this.time
      t.d = parseInt(remain / (60 * 60 * 24), 10)
      if (t.d < 10) t.d = '0' + t.d
      t.h = `0${parseInt((remain % (60 * 60 * 24)) / (60 * 60))}`.substr(-2)
      t.m = `0${parseInt((remain % (60 * 60)) / 60)}`.substr(-2)
      t.s = `0${parseInt(remain % 60)}`.substr(-2)
    },
    getTime(time) {
      const ts =
        typeof time === 'string' ? time.toString().replace(/-/g, '/') : time
      const t = ts && new Date(ts).getTime()
      return t
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.showShare = utils.isHzwApp() || this.isMinProgram
    this.nowTime =
      this.seckillData && (this.seckillData.serviceTime || new Date().getTime())
    this.countDown(
      remain => {
        remain && this.splitTime(remain)
      },
      remain => {
        remain && this.splitTime(remain)
      }
    )
  }
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
@import '~@/assets/css/mixin';
.seckill-xwrap {
  img {
    position: absolute;
    height: rem(130px);
    left: 0;
    right: 0;
    z-index: 0;
    // height: rem(222px);
  }
  .seckill {
    padding: 0 rem(30px);
    height: rem(130px);
    background-size: rem(750px) auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    // background: url('~@/assets/images/product/new/seckill-bg.png');
    .left {
      position: relative;
      z-index: 1;
      .t {
        display: flex;
        align-items: center;
        .tips {
          display: flex;
          align-items: flex-end;
          .icon {
            font-size: rem(28px);
            color: #ffffff;
            font-size: 600;
          }
          .count {
            margin-left: rem(6px);
            font-size: rem(48px);
            color: #ffffff;
            line-height: 1;
            .line {
              font-size: rem(24px);
            }
          }
        }

        .sk {
          margin-left: rem(12px);
          line-height: 1;
          padding: 0.09rem 0.14rem 0.07rem;
          font-size: rem(24px);
          color: #fe4f4c;
          background: #ffffff;
          border-radius: rem(100px);
        }

        .share-earn-money {
          /deep/.spu-earn {
            display: flex;
            align-items: center;
            border-radius: rem(30px);
            margin-left: rem(12px);
            background: #fff;
            color: #ff5900;
            overflow: hidden;
            .spu-earn-icon {
              height: rem(36px);
              line-height: rem(34px);
              color: #ff5900;
              background: url('~@/assets/images/icon-money-seckill.png')
                rem(12px) center/ rem(20px) rem(22px) no-repeat;
              border: 1px solid rgba(255, 89, 0, 0.4);
            }
            .spu-earn-money {
              background-color: transparent;
              line-height: rem(32px);
              border: 1px solid rgba(255, 89, 0, 0.2);
              border-left-width: 0;
              @include ellicpsis;
            }
          }
        }
      }
      .normal {
        margin-top: rem(8px);
        font-size: rem(22px);
        color: #ffffff;
        .n-icon {
          margin-left: 0.06rem;
        }
      }
    }
    .right {
      position: relative;
      z-index: 1;
      text-align: right;
      .t {
        font-size: rem(24px);
        color: #fff;
        letter-spacing: 0;
        font-weight: 700;
      }
      .b {
        margin-top: rem(14px);
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .num {
          box-sizing: content-box;
          padding-top: 0.01rem;
          padding-bottom: 0.01rem;
          display: inline-block;
          text-align: center;
          height: rem(32px);
          line-height: rem(32px);
          font-size: rem(24px);
          color: #ffffff;
        }
        .string {
          font-size: rem(20px);
          color: #fff;
        }
      }
    }
  }
  .suptitle {
    margin: 0 rem(30px);
    padding: rem(24px) 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;

    .share_btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      .img {
        width: rem(35px);
        height: rem(35px);
        position: relative;
      }
      span {
        margin-top: rem(6px);
        color: #333;
        font-size: rem(24px);
      }
    }
  }
}
.title {
  flex: 1;
  font-size: rem(32px);
  color: #333333;
  letter-spacing: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
